import { Col, Form, InputGroup, Spinner } from "react-bootstrap";
import { euroCents, usePricing } from "../../context/pricing/PricingContext";

/**
 * Toont het bedrag van een onderdeel: de som van de calculatieregels met deze
 * code(s). Eén onderdeel kan uit meerdere regels bestaan — bij een draai de
 * profielen in 100, 120 en 140 cm, en "de trap" is profielen + treden +
 * deelfineer.
 *
 * De frontend rekent zelf niets uit: staat het onderdeel niet in het antwoord
 * van de server, dan is er geen bedrag om te tonen. Tijdens het herrekenen
 * verschijnt een spinner in plaats van het vorige bedrag — een oud bedrag naast
 * een nieuwe keuze zou misleidend zijn.
 */
export default function RegelBedrag({
  code,
  label = "Prijs",
  sizes = { xs: 6, md: 3 },
}: {
  code: string | string[];
  label?: string;
  sizes?: { xs?: number; md?: number };
}) {
  const { regels, loading, error } = usePricing();
  const gevonden = regels(code);
  const totaal = gevonden.reduce((som, l) => som + l.regeltotaalCents, 0);

  return (
    <Form.Group className="auth-input" as={Col} {...sizes}>
      <Form.Label>{label}</Form.Label>
      <InputGroup className="auth-input">
        <InputGroup.Text
          style={{
            boxShadow: "none",
            border: "none",
            backgroundColor: "transparent",
            color: "#6c757d",
          }}
        >
          €
        </InputGroup.Text>
        {loading ? (
          <Form.Control
            as="div"
            className="d-flex align-items-center"
            style={{ backgroundColor: "#e9ecef" }}
          >
            <Spinner animation="border" size="sm" className="text-secondary" />
          </Form.Control>
        ) : (
          <Form.Control
            type="text"
            disabled
            value={
              error
                ? "—"
                : gevonden.length > 0
                ? euroCents(totaal).replace("€", "").trim()
                : "—"
            }
          />
        )}
      </InputGroup>
    </Form.Group>
  );
}

/**
 * Het aantal van een onderdeel, zoals de backend het heeft bepaald: opgeteld
 * over alle maten (bij een draai 11 + 2 + 1 profielen = 14).
 */
export function RegelAantal({
  code,
  label = "Aantal",
  sizes = { xs: 6, md: 3 },
}: {
  code: string;
  label?: string;
  sizes?: { xs?: number; md?: number };
}) {
  const { regels, loading } = usePricing();
  const gevonden = regels(code);
  const aantal = gevonden.reduce((som, l) => som + l.aantal, 0);

  return (
    <Form.Group className="auth-input" as={Col} {...sizes}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type="text"
        disabled
        value={loading ? "…" : gevonden.length > 0 ? String(aantal) : "—"}
      />
    </Form.Group>
  );
}
